import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=75394b1a&scoped=true"
import script from "./accountSetting.vue?vue&type=script&lang=ts"
export * from "./accountSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75394b1a",
  null
  
)

export default component.exports